import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger, LoggingService } from 'ionic-logging-service';
import { Observable } from 'rxjs';
import { delay, finalize, retryWhen, take, tap } from 'rxjs/operators';
import { LanguageService } from '../language/language.service';
import { IWorkflow } from './models/workflow.model';

@Injectable({
  providedIn: 'root'
})
export class CaptureUploadService {

  private logger: Logger;
  private httpErrorResponse: HttpErrorResponse;
  public workflow: IWorkflow;
  public workflowList: Array<IWorkflow>;
  public imagesArray: Array<any>;
  private processingStatussesArray = [];

  constructor(
    private httpClient: HttpClient,
    private languageService: LanguageService,
    private loggingService: LoggingService,
  ) {
      this.logger = this.loggingService.getLogger("[CaptureService]");
      const methodName = "ctor";
      this.logger.entry(methodName);
    }

  public startCaptureUpload(workflow: IWorkflow, imagesArray: any): Observable<any> {
    let startCaptureUploadUrl = workflow.links.scans;
    let imageCount = imagesArray.length;
    return new Observable((observer) => {
      this.httpClient.post<any>(startCaptureUploadUrl, {inputFileCount: imageCount})
      // this.httpClient.post<any>(startCaptureUploadUrl, {})
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(3),
        // return httpErrorResponse.status > 499 ? Observable.of(true) : Observable.throw(httpErrorResponse);
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
            observer.error(this.httpErrorResponse);
            observer.complete();
        })
      ))).subscribe((uploadStartedResponse) => {
        console.log('start capture upload response', uploadStartedResponse);
		    let uploadFinishedCount = 0; // also used to set the index for which uploadFile link to use for uploading a specific image file in uploadCaptureToServer()
        let uploadFileIndex = uploadFinishedCount -1;
        imagesArray.forEach(imgObj => {
          uploadFileIndex++;
          this.uploadCaptureToServer(uploadStartedResponse, imgObj.imgBlob, imgObj.imgSize, uploadFileIndex)
          .subscribe((response) => {
            uploadFinishedCount++;
            if (uploadFinishedCount === imageCount) {
              observer.next(response);
              observer.complete();
            };
          });
        });
      });
    });
  }

  public uploadCaptureToServer(uploadStartedResponse, imageBlob, imageSize, uploadFileIndex): Observable<any> {
    console.log('UPLOAD_CAPTURE_TO_SERVER()');
    console.log('imageBlob', imageBlob);
    console.log('uploadStartedResponse', uploadStartedResponse);
    console.log('uploadFileIndex', uploadFileIndex);
    const uploadLink = uploadStartedResponse['currentActivity']['_embedded']['uploadFiles'][uploadFileIndex]['uploadLink'];
    console.log('uploadLink', uploadLink);
    const uploadHeaders = uploadStartedResponse['currentActivity']['_embedded']['uploadFiles'][uploadFileIndex]['uploadHeaders'];
    console.log('uploadHeaders', uploadHeaders);
    const finishUploadLink = uploadStartedResponse['currentActivity']['_embedded']['uploadFiles'][uploadFileIndex]['_links']['px:finishUploads']['href'];
    console.log('finishUploadLink', finishUploadLink);
    return new Observable((observer) => {
      this.httpClient.put<any>(uploadLink, imageBlob, {headers: uploadHeaders})
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(3),
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
          observer.error(this.httpErrorResponse);
          observer.complete();
        })
      )))
      .subscribe((uploadFinishedResponse) => {
        this.confirmUpload(finishUploadLink, imageSize)
        .subscribe((res) => {
          observer.next(res);
          observer.complete();
        });
      });
    })
  }

  private confirmUpload(finishUploadLink, imageSize): Observable<any> {
    console.log('## CONFIRM_UPLOAD');
    const objectPost: any = {
        "pages": 1,
        "fileSize": imageSize,
        "mimeType": "image/jpg"
    }

    return new Observable((observer) => {
      this.httpClient.post<any>(finishUploadLink, objectPost)
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(3),
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
          observer.error(this.httpErrorResponse);
          observer.complete();
        })
      )))
      .subscribe((response) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  public getScanUpdatedData(data): Observable<any> {
    // set accept language header: Accept-Language
    const currentLanguage = this.languageService.getCurrentLanguageCode();
    const languageHeader = new HttpHeaders({
      'Accept-Language': currentLanguage
    });
    return new Observable((observer) => {
      this.httpClient.get<any>(data.scan, {headers: languageHeader})
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(3),
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
          observer.error(this.httpErrorResponse);
          observer.complete();
        })
      )))
      .subscribe((response) => {
        observer.next(response);
        observer.complete();
      });
    })
  }

  public checkFileProcessingStateOnServer(scanUpdated): Observable<any> {
    let processingPending = false;
    if (scanUpdated.state === 'RUNNING') {
      this.processingStatussesArray.push(scanUpdated);
    } else if (scanUpdated.state === 'FINISHED') {

    }
    return new Observable((observer) => {
      observer.next(processingPending);
      observer.complete();
    });
  }
}